import Image from 'next/image'
import s from './insurance.module.scss'

export const InsuranceHeaderBanner = () => {
  return (
    <section className={s.containerHeader}>
      <div className={s.imageDesktop}>
        <Image
          src="/insurance/insurance-header-desk.png"
          alt="Dachshund puppy having a medical check-up"
          width={1074}
          height={250}
          quality={100}
          priority
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>

      <div className={s.imageMobile}>
        <Image
          src="/insurance/insurance-header-mobile.png"
          alt="Dachshund puppy having a medical check-up"
          width={400}
          height={200}
          quality={100}
          priority
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>

      <div className={s.iconSectionDesk}>
        <img
          src="/insurance/customer/insurance-icon-green.svg"
          alt="icon insurance"
        />
      </div>
      <div className={s.iconSectionMob}>
        <img
          src="/insurance/customer/insurance-icon-green-mob.svg"
          alt="icon insurance"
        />
      </div>
    </section>
  )
}

export const InsuranceLayout = ({ children }) => {
  return (
    <>
      <InsuranceHeaderBanner />

      <section className={s.dataSection}>
        <div className={s.header}>
          <h1 className={s.title}>Consider Pet Insurance for Your Puppy</h1>
          <p className={s.subtitle}>
            Our insurance partners offer plans tailored to your needs and to
            protect your new family member. Please reach out with any questions
            using the contact details below!
          </p>
          <div className={s.question}>
            <b>Questions?</b> Contact our dedicated pet insurance advisor
            Matthew Nash at <br />
            <a
              href="tel:+925-238-6078"
              onClick={() => {
                // GTM call
                if (window.dataLayer) {
                  window.dataLayer.push({ event: 'call' })
                }
              }}
            >
              {' '}
              925-238-6078
            </a>{' '}
            or <a href="mailto:matt@theswiftest.com"> via email</a>.
          </div>
        </div>
      </section>

      {children}

      <section className={s.dataSection_2}>
        <div className={s.swiftestSection}>
          <div className={s.data}>
            <img src="/insurance/theswiftest.svg" alt="the swiftest icon" />
            <p>
              The Swiftest is a trusted pet insurance advisor dedicated to
              finding the best coverage option for your new family member. They
              offer a range of policies from leading insurance providers,
              allowing you to choose the plan that best fits your budget and
              needs.
            </p>
          </div>
          <div className={s.image}>
            <Image
              src="/insurance/customer/img-puppy-prof-circle.png"
              width={250}
              height={250}
              alt="Woman hugs your dog"
              quality={100}
              objectFit="fill"
            />
          </div>
        </div>
      </section>
    </>
  )
}
